export default "__VITE_ASSET__D4L_xypw__"